import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox';
import { can } from '../../../../../services';
import styles from 'styles/form';
import HelperForm from './helperForm';
import CrewForm from './crewForm';

const InstallerCrewForm = (props) => {
  const { errors, helpers, crews, onHelperChange, onCrewChange, onCrewSpecificChange,
          onAddHelper, onAddCrew, onRemoveCrew, onDeleteHelper, onDisableChange,
          onDailyChange, onSurfaceTypesChange, onAvailabilityChange, allWorkrooms,
          workroomChange, role, invalidCrewFieldsMsgs, invalidHelperFieldsMsgs,
          fieldError } = props;
  const canEdit = can(role, 'update', 'crew');
  const canEditBasic = can(role, 'update_basic', 'crew');
  const scrollTo = () => {
    const arrOfElement = document.getElementsByClassName('crewForm__crewContainer___1YwHM');
    if (!arrOfElement.length) return;
    const headerOffset = 160;
    const elementPos = arrOfElement[arrOfElement.length - 1].getBoundingClientRect().top;
    /* eslint no-mixed-operators: ["error", {"allowSamePrecedence": true}]*/
    const offsetPos = elementPos + window.pageYOffset - headerOffset;
    if (event.target.id === 'addNewCrew') window.scrollTo({ top: offsetPos, behavior: 'smooth' });
  };
  window.addEventListener('click', scrollTo);
  return (<div>
    <div className={styles.divider}>
      <h5 className={styles.childTitle}>Crew Management
        {canEdit && <Button
          id="addNewCrew"
          className={styles.addChildButton}
          onClick={onAddCrew}
          label="Add a Crew"
        />}
      </h5>
      {(errors.crews && crews && crews.length === 0) &&
        <div className={styles.errorText}>{errors.crews[0]}</div>}
      {crews.map((crew, i) => (<CrewForm
        key={'crew-'.concat(crew.id)}
        crew={crew}
        errors={errors}
        crewFieldWarnings={invalidCrewFieldsMsgs.length ?
          invalidCrewFieldsMsgs.filter(m => m.id === crew.id) : []}
        allWorkrooms={allWorkrooms}
        onChange={(key, value) => onCrewChange(crew.id, key, value)}
        onSpecificChange={(key, value) => onCrewSpecificChange(crew.id, key, value)}
        onSurfaceTypesChange={(key, value) => onSurfaceTypesChange(crew.id, key, value)}
        onAvailabilityChange={value => onAvailabilityChange(crew.id, value)}
        onDailyChange={(key, value) => onDailyChange(crew.id, key, value)}
        onDelete={onRemoveCrew}
        index={i}
        canRemoveCrew={crews.length > 1}
        canEdit={canEdit}
        canEditBasic={canEditBasic}
        workroomChange={workroomChange}
        fieldError={fieldError}
      />))}
      {canEdit && <div>
        <h5 className={styles.childTitle}>Helpers
          <Button className={styles.addChildButton} onClick={onAddHelper} label="Add a Helper" />
        </h5>
        {helpers.map((helper, i) => (<HelperForm
          key={'helper-'.concat(helper.id)}
          helper={helper}
          errors={errors}
          onChange={(key, value) => onHelperChange(helper.id, key, value)}
          index={i}
          onDelete={onDeleteHelper}
          onDisable={(key, value) => onDisableChange(helper.id, key, value)}
          helperFieldWarnings={invalidHelperFieldsMsgs.length ?
            invalidHelperFieldsMsgs.filter(m => m.id === helper.id) : []}
          fieldError={fieldError}
        />))}
      </div>}
    </div>
  </div>);
};

InstallerCrewForm.propTypes = {
  onDisableChange: PropTypes.func,
  onAddHelper: PropTypes.func,
  onAddCrew: PropTypes.func,
  onRemoveCrew: PropTypes.func,
  onDeleteHelper: PropTypes.func,
  onSurfaceTypesChange: PropTypes.func,
  onHelperChange: PropTypes.func,
  onCrewChange: PropTypes.func,
  onCrewSpecificChange: PropTypes.func,
  onAvailabilityChange: PropTypes.func,
  onDailyChange: PropTypes.func,
  errors: PropTypes.object,
  allWorkrooms: PropTypes.array,
  helpers: PropTypes.array,
  crews: PropTypes.array,
  role: PropTypes.string.isRequired,
  workroomChange: PropTypes.bool,
  invalidCrewFieldsMsgs: PropTypes.array,
  invalidHelperFieldsMsgs: PropTypes.array,
  fieldError: PropTypes.func,
};

export default InstallerCrewForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerCrewForm.jsx